module.exports = __webpack_public_path__ + "media/images/Dashboard-icon-c890b112e28a4bcf2569008111c516aa.svg";